import { Component, OnInit } from '@angular/core';
import { ChartOptions } from 'chart.js';
import { BehaviorSubject } from 'rxjs';
import { GraphDataResponse, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { formatDateTimeHuman } from '../../../ui-components/standard-date.pipe';

@Component({
  selector: 'sa-pending-load-by-hour',
  styleUrls: ['./pending-load-by-hour.component.scss'],
  templateUrl: './pending-load-by-hour.component.html',
})
export class PendingLoadByHourComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public loading = false;
  public timeframe = 3;
  public datasets: GraphDataResponse = this.initializePendingLoadByHour();
  public isNoDataSubject$$ = new BehaviorSubject<boolean>(true);

  public chartColors: any[] = [
    {
      backgroundColor: ['rgb(32,118,135, 0.5)'],
      borderColor: ['rgb(32,118,135)'],
    },
  ];

  public options: ChartOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetPendingLoadByHour();
      this.regionID = regionID;
      this.fetchPendingLoadByHour();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetPendingLoadByHour();
        this.fracsID = fracsID;
        this.fetchPendingLoadByHour();
      }

      if (fracsID.length < 1 && this.regionID) {
        this.resetPendingLoadByHour();
        this.fetchPendingLoadByHour();
      }
    });
  }

  private fetchPendingLoadByHour(): void {
    this.loading = true;
    this.isNoDataSubject$$ = new BehaviorSubject<boolean>(false);
    const pendingLoadByHourTimeframe = this.kpiDashboardService.getLocalStorage('pending_load_by_hour_timeframe');
    if (pendingLoadByHourTimeframe) {
      this.timeframe = pendingLoadByHourTimeframe;
    }
    this.kpiDashboardService.getPendingLoadByHour$(this.regionID, this.fracsID, this.timeframe).subscribe((data) => {
      this.datasets = data;

      this.datasets.labels.map((label, index) => {
        this.datasets.labels[index] = formatDateTimeHuman(label);
      });

      data.datasets.forEach((value) => {
        const sum = value.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        if (value.data.length !== 0 && sum !== 0) {
          this.isNoDataSubject$$?.next(false);
        } else {
          this.isNoDataSubject$$?.next(true);
        }
      });

      this.loading = false;
    });
  }

  private resetPendingLoadByHour(): void {
    this.datasets = this.initializePendingLoadByHour();
  }

  private initializePendingLoadByHour(): GraphDataResponse {
    this.isNoDataSubject$$?.next(true);
    return {
      datasets: [
        {
          data: [0],
          label: '',
        },
      ],
      labels: [''],
    };
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('pending_load_by_hour_timeframe', this.timeframe);
    this.fetchPendingLoadByHour();
  }
}
